import * as React from 'react';
import { formatUserDate, OwaDate } from 'owa-datetime';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { getAsset, setDueDate, setAnnouncement } from 'owa-timestream-store';
import {
    updateTodoDueDate,
    deleteTodo,
    spacesTodoActionTelemetryData,
} from 'owa-timestream-asset-sdk-tasks';
import { dueDateSetAnnouncement } from '../dueDates.locstring.json';
import loc from 'owa-localize';

export default function useSetDueDate(
    projectId: ProjectId,
    assetId: AssetId,
    deleteTaskOnDateRemoval: boolean
): (dueDate: OwaDate | null) => void {
    return React.useMemo(
        () => setDueDateAndUpdateTask.bind(null, projectId, assetId, deleteTaskOnDateRemoval),
        [projectId, assetId, deleteTaskOnDateRemoval]
    );
}

function setDueDateAndUpdateTask(
    projectId: ProjectId,
    assetId: AssetId,
    deleteTaskOnDateRemoval: boolean,
    dueDate: OwaDate | null
) {
    const { taskId } = getAsset(projectId, assetId);
    const shouldRemoveTask = deleteTaskOnDateRemoval && !dueDate;
    if (taskId) {
        if (shouldRemoveTask) {
            deleteTodo(taskId, spacesTodoActionTelemetryData);
        } else {
            setAnnouncement(loc(dueDateSetAnnouncement, formatUserDate(dueDate!)));
            updateTodoDueDate(taskId, dueDate, spacesTodoActionTelemetryData);
        }
    }

    setDueDate(projectId, assetId, dueDate, shouldRemoveTask);
}
